import { render, staticRenderFns } from "./privilege.vue?vue&type=template&id=d1af887a&scoped=true"
import script from "./privilege.vue?vue&type=script&lang=js"
export * from "./privilege.vue?vue&type=script&lang=js"
import style0 from "./privilege.vue?vue&type=style&index=0&id=d1af887a&prod&scoped=true&lang=scss"
import style1 from "./privilege.vue?vue&type=style&index=1&id=d1af887a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1af887a",
  null
  
)

export default component.exports